<template>
  <el-dialog
    :title="$t('deleteInoutOrder.confirmTitle')"
    :visible.sync="visible"
    width="30%"
    @close="close"
  >
    <div align="center">
      <p>{{ $t('deleteInoutOrder.confirmText') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="deleteInoutOrder">{{ $t('common.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteInoutOrder } from '@/api/goods/inoutOrderApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteInoutOrder',
  data() {
    return {
      visible: false,
      deleteInoutOrderInfo: {}
    }
  },
  methods: {
    open(data) {
      this.deleteInoutOrderInfo = data
      this.visible = true
    },
    close() {
      this.visible = false
    },
    async deleteInoutOrder() {
      this.deleteInoutOrderInfo.shopId = getShopId()
      try {
        await deleteInoutOrder(this.deleteInoutOrderInfo)
        this.$emit('refresh')
        this.close()
        this.$message.success(this.$t('common.submitSuccess'))
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>